import { CustomButton, CustomFlex, Paragraph } from "../Layout.elements";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import TableGridSection from "../TableGridSection";
import BlackScreen from "../BlackScreen";
import CrossButton from "../buttons/CrossButton";
import styled from "@emotion/styled";

const FlexContainer = styled(CustomFlex)`
  margin: 0 5rem;
  @media only screen and (max-width: 768px) {
    margin: 0 1.5rem !important;
    position: absolute;
    bottom: 15%;
    display: grid;
  }
  @media (min-width: 769px) {
    margin-bottom: 100px;
  }
`;

const ButtonDiv = styled(CustomButton)`
@media (max-width: 768px) {
  padding: 0;
}
`;

const Examples = ({
  onCrossButtonChange,
  onQuesChange,
  setBlackScreen,
  setOpenAllResponseScreen,
  allResponseScreen,
  setQueryIndex,
  setPageNumber,
  setQueryParams,
  setDynamicCodeSection
}) => {
  const params = new URLSearchParams(window.location.search);
  const handleCrossButtonChange = () => {
    onCrossButtonChange(false);
  };
  const handleQueryChange = (value) => {
    onQuesChange(value);
  };
  const handleAllResponse = () => {
    setBlackScreen(false);
    setOpenAllResponseScreen(!allResponseScreen);
    params.set("q", "all");
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState({ path: newUrl }, "", newUrl);
    window.scrollTo({ top: 0, behavior: "smooth" });
    setQueryParams(params.toString());
  };
  return (
    <>
      <BlackScreen
        onQueryChanged={handleQueryChange}
        setBlackScreen={setBlackScreen}
        setQueryIndex={setQueryIndex}
        setPageNumber={setPageNumber}
        setDynamicCodeSection={setDynamicCodeSection}
        justifyContent="flex-end"
      >
        <div>
          <CrossButton
            onCrossButtonChange={handleCrossButtonChange}
            setBlackScreen={setBlackScreen}
            setQueryParams={setQueryParams}
          />
        </div>
          <FlexContainer direction="column" content="center" align="flex-start">
              <Paragraph>Examples to get you started</Paragraph>
              <div>
                <ButtonDiv
                  variant="text"
                  size="medium"
                  color="inherit"
                  endIcon={<ArrowForwardIcon />}
                  onClick={handleAllResponse}
                >
                  All Inputs & Answers
                </ButtonDiv>
              </div>
              <TableGridSection
                border="1px solid white"
                setQueryIndex={setQueryIndex}
                btnTextColor="white"
                setBlackScreen={setBlackScreen}
                setQueryParams={setQueryParams}
              />
          </FlexContainer>
      </BlackScreen>
    </>
  );
};
export default Examples;
